export default __webpack_public_path__ + "images/NX.4547d4b.png";